// 快看
const list = [
  {
    id:'1',
    name: '废女妖神',
    desc: ['逆袭', '恋爱'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/201125/g7IIhVX4C.webp-t.w207.webp.h',
    instr: '妖尊白又灵大婚当日妖力狂化暴走，被爱人一剑穿心。白又灵含恨丹破而终。再醒来，竟然借同名白家废女身体重生。打脸渣男贱女，重走修炼巅峰，没想到再遇旧人，还成了他的徒弟。你们这些满腹仁义，道貌岸然的伪君子，都给我洗干净脖子等着！ “尤其是你，许奚渊，你也尝尝被爱人亲手了断的滋味吧！”',
    pcLink:'https://www.qiremanhua.com/book/11004/',
    mobileLink:'https://m.qiremanhua.com/book/11004/'
  },
  {
    id:'2',
    name: '萌妻有点皮',
    desc: ['总裁', '恋爱'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/190213/HpMT0gPny.webp-t.w207.webp.h',
    pcLink:'https://www.qiremanhua.com/book/10487/',
    mobileLink:'https://m.qiremanhua.com/book/10487/',
    instr: '一场始于真心话大冒险的乌龙邂逅？一晚醉酒误与被子缱绻缠绵的暧昧之夜？他舔了舔自己渗着血珠的唇，一脸危险; 他红着脸把头埋入她的脖颈间，轻声撒娇。谁说冤家宜解不宜结？五大帅哥组团爆笑来袭，双面总裁就是非要赖上你！ 【每周三/周六双更】'
  },
  {
    id:'3',
    name: '神武帝尊',
    desc: ['重生', '逆袭'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/200324/XN81lRlZv.webp-t.w207.webp.h',
    pcLink:'https://www.qiremanhua.com/book/10910/',
    mobileLink:'https://m.qiremanhua.com/book/10910/',
    instr: '一代大能高手，遭人算计，机缘巧合之下重活于世，借助上一世的修行经验，踩天才无数，踏高手如云，神挡杀神，佛挡杀佛，强势回归诸天万界! 【每周五更新】快来找我们玩~'
  },
 
  {
    id:'5',
    name: '抢个道爷当娘子',
    desc: ['纯爱', '古风'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/211014/MjFt4UnCk.webp-t.w207.webp.h',
    pcLink:'https://www.qiremanhua.com/book/11132/',
    mobileLink:'https://m.qiremanhua.com/book/11132/',
    instr: '被封印十世的魔尊一朝醒来，没了大半法力只能暂时骂骂咧咧的化形为的翩翩公子，路遇男扮女装的道士被人浸猪笼？！这货长得竟然和当年跟我作对的家伙一模一样！先救下来慢慢折磨他……'
  },

 
]
export default list